import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable()
export class UserContext {
  userID: string;
  personID: string;
  organisationID: string;
  userName: string;
  isAuthenticated: boolean;
  expiryToken: Date | any;
  tenantID: string;
  token: string;
  createdToken: Date | any;

  constructor() {
    let jwtHelper = new JwtHelperService();
    this.userID = "";
    this.personID = "";
    this.isAuthenticated = false;
    this.userName = "";
    this.expiryToken = null;
    this.createdToken = null;
    if (localStorage.getItem("currentUser")) {
      const tkn: any = JSON.parse(localStorage.getItem("currentUser"))?.token;
      const tknData: any = jwtHelper.decodeToken(tkn);
      this.tenantID = tknData.tenant;
      this.isAuthenticated = tkn != null && !jwtHelper.isTokenExpired(tkn);
      this.userID = tknData.usrId;
      this.organisationID = tknData.orgId;
      this.personID = tknData.sub;
      this.userName = tknData.usr;
      this.token = tkn.toString();
      this.expiryToken = jwtHelper.getTokenExpirationDate(tkn);
      this.createdToken = new Date(tknData.iat * 1000);
    }
  }
}
